(function($) {
  $(window).on('load', function() {
    setTimeout(function() {
      var cookieRefreshAPI = '/buyer/api/v1/itp_forward';

      $.ajax(cookieRefreshAPI);
    }, 100)
  });
}(jQuery));
